export function findMetaTreeIndex(areaList, targetAreaId) {
	return areaList.findIndex(item => item && item.pk_area === targetAreaId)
}
